import { Configuration, LogLevel } from "@azure/msal-browser"

// Log the actual redirect URI being used to help with debugging
const redirectUri = window.location.origin

export const msalConfig: Configuration = {
  auth: {
    clientId: "58c3d6d6-a931-4e60-bb55-5ee117dabc7e",
    authority: `https://login.microsoftonline.com/de2edb44-6ad6-4046-b64c-8c8151da6001`, // Fallback
    redirectUri: redirectUri, // Using current origin as redirect URI
  },
  cache: {
    cacheLocation: "localStorage", // This enables persistent user sessions
    storeAuthStateInCookie: false, // Set to true for IE11 or if you have issues on Safari ITP
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            // console.info(message); // Avoid too much noise in console
            return
          case LogLevel.Verbose:
            // console.debug(message); // Avoid too much noise in console
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"], // Added openid, profile, email for a richer ID token
}

// Configuration for accessing your own backend API
export const apiConfig = {
  scopes: [`${msalConfig.auth.clientId}/.default`], // e.g., "[client-id]/.default"
  uri: "/query", // Base URI for your API, can be used if you have multiple resources
}
